import { cn } from "@/lib/utils";

const TONES = {
  neutral: "border-border bg-background/60 text-foreground",
  primary: "border-primary/20 bg-primary/5 text-primary",
  forest: "border-accent/20 bg-accent/5 text-accent",
  sky: "border-info/20 bg-info/5 text-info",
  clay: "border-warning/30 bg-warning/10 text-warning-foreground",
};

/**
 * A labelled number: "Raised · $915". The one stat tile for dashboards,
 * student pages and the setup guide. Colour goes on the value; the label
 * stays muted so it's readable on every tint.
 */
export default function StatTile({ icon: Icon, label, value, hint, color = "neutral", size = "md", className, children }) {
  return (
    <div className={cn("rounded-lg border", size === "sm" ? "px-3 py-2.5" : "px-4 py-3", TONES[color], className)}>
      <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        {Icon && <Icon className="h-3.5 w-3.5" aria-hidden="true" />}
        {label}
      </p>
      <p className={cn("mt-1 font-display font-semibold leading-none font-tabular", size === "sm" ? "text-lg" : "text-2xl")}>{value}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
      {children}
    </div>
  );
}
